import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../../app.constants';
import { IonicAngular4CacheService } from 'ionic-angular4-cache';
import { ToastService } from '../../shared/services/toast.service';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor(
    private _http: HttpClient,
    private config: Configuration,
    public ionicAngular4Cache: IonicAngular4CacheService,
    public toastService: ToastService
  ) { }

  public search(skip, limit, query, sort, fieldsToGet) {
    return new Promise((ok, notOk) => {
      const queryData = { 'query': query, 'sort': sort, fieldsToGet: fieldsToGet };
      const searchOrganizationObservable = this._http.post(`${this.config.ServerApiUrl}/product/search/${skip * limit}/${limit}`,
        queryData);
      searchOrganizationObservable.subscribe(data => {
        this.ionicAngular4Cache.saveItemOld(`productSearch`, data);
        ok(data);
      });
    });
  }

  public getProductCount(query) {
    const queryData = {'query': query};
    return this._http.post(`${this.config.ServerApiUrl}/product/productCount`, queryData);
  
  }

  public getProductReportingHubCount(query) {
    const queryData = { 'query': query };
    return this._http.post(`${this.config.ServerApiUrl}/product/productReportingHubCount`, queryData);

  }

  public getProduct(id) {
    return this._http.post(`${this.config.ServerApiUrl}/product/getProduct`, { id: id });
  }

  public createProduct(productObj) {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/product/createProduct`,
        { productObj: productObj }).subscribe(data => {
          ok(data);
        }, err => {
          notOk(err);
        });
    });
  }

  public validateCard(proId, cardObj, cardName, status) {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/product/validateCard`,
        { proId, cardObj, cardName, status }).subscribe(data => {
          ok(data);
        }, err => {
          notOk(err);
        });
    });
  }

  public updateProduct(product) {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/product/updateProduct`,
        product).subscribe(data => {
          ok(data);
        }, err => {
          notOk(err);
        });
    });
  }

  public getReportingHubData(query) {
    const queryData = { 'query': query };
      return this._http.post(`${this.config.ServerApiUrl}/product/getReportingHubData`,
        queryData)
  }

  public prodCatsGraphData(query) {
    const queryData = { 'query': query };
    return this._http.post(`${this.config.ServerApiUrl}/product/prodCatsGraph`,
      queryData)
  }

  public supplierGraphData(query) {
    const queryData = { 'query': query };
    return this._http.post(`${this.config.ServerApiUrl}/product/supplierGraph`,
      queryData)
  }


  public countryGraphData(query) {
    const queryData = { 'query': query };
    return this._http.post(`${this.config.ServerApiUrl}/product/countryGraph`,
      queryData)
  }
  
  public getProductsDataAnalysis(fieldsToGet , query ) {
    const queryData = { fieldsToGet: fieldsToGet, 'query': query};
    return this._http.post(`${this.config.ServerApiUrl}/product/getProductsDataAnalysis`,queryData)
  }

  public getSuppliersDataAnalysis(fieldsToGet, query) {
    const queryData = { fieldsToGet: fieldsToGet, 'query': query };
    return this._http.post(`${this.config.ServerApiUrl}/product/getSuppliersDataAnalysis`, queryData)
  }

  public getListFilterValues() {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/product/getListFilterValues`,
        {}).subscribe(data => {
          ok(data);
        });
    });
  }

  public massImport(products) {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/product/massImport`,
        products).subscribe(data => {
          ok(data);
        });
    });
  }

  public partNumberMatching(partNumbers, bulkImport, filters) {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/product/partNumberMatching`,
        { partNumbers: partNumbers, bulkImport: bulkImport, filters: filters }).subscribe(data => {
          ok(data);
        });
    });
  }

  public changeArchiveStatus(status, productId) {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/product/changeArchiveStatus`,
        { status: status, productId: productId }).subscribe(data => {
          ok(data);
        });
    });
  }

  public uploadFileAndGetUrl(file) {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/product/uploadFileAndGetUrl`,
        { file: file }).subscribe(data => {
          ok(data);
        });
    });
  }

  public uploadFiles(file) {
    return new Promise((resolve, reject) => {
      this._http.post(`${this.config.ServerApiUrl}/product/uploadFiles`, { file: file }).subscribe(data => {
        resolve(data);
      });
    });
  }

  // products suppliers 
  public getAllSuppliers(skip, limit, query) {
    const queryData = { 'query': query };
    return this._http.post(`${this.config.ServerApiUrl}/supplier/getAllSuppliers/${skip * limit}/${limit}`, queryData);
  }
  public addSupplier(data) {
    return this._http.post(`${this.config.ServerApiUrl}/supplier/addSupplier`, data)
  }
  public editSupplier(data) {
    return this._http.patch(`${this.config.ServerApiUrl}/supplier/editSupplier`, data)
  }
  public suppliersList(data) {
    return this._http.post(`${this.config.ServerApiUrl}/supplier/allsupplliers`, {
      data: data
    })
  }
  public getSupplierManufacturer(data) {
    return this._http.post(`${this.config.ServerApiUrl}/supplier/getSuppliersManufacturers`, {
      data: data
    })
  }
  public supplierArchiveStatus(status, supplierId) {
    return this._http.post(`${this.config.ServerApiUrl}/supplier/archiveStatus`, { status: status, supplierId: supplierId })
  }
  // products manufacturer
  public getAllManufacturers(skip, limit, query) {
    const queryData = { 'query': query };
    return this._http.post(`${this.config.ServerApiUrl}/manufacturer/getAllManufacturers/${skip * limit}/${limit}`, queryData);
  }
  public addManufacturer(data) {
    return this._http.post(`${this.config.ServerApiUrl}/manufacturer/addManufacturer`, data)
  }
  public editManufacturer(data) {
    return this._http.patch(`${this.config.ServerApiUrl}/manufacturer/editManufacturer`, data)
  }
  public manufacturersList(data) {
    return this._http.post(`${this.config.ServerApiUrl}/manufacturer/allManufacturers`, {
      data: data
    });
  }
  public getSingleManufacturer(id) {
    return this._http.post(`${this.config.ServerApiUrl}/manufacturer/getManufacturer`,{id:id});
  }
  public manufacturerArchiveStatus(status, manufacturerId) {
    return this._http.post(`${this.config.ServerApiUrl}/manufacturer/archiveStatus`, { status: status, manufacturerId: manufacturerId })
  }
  // public matchShortDescription(data) {
  //   return this._http.post(`${this.config.ServerApiUrl}/product/getPossibleMatch`, {data:data})
  // }

  public productsSearch(data, userEmail ,isCompetitor) {
    if (userEmail) {
      this.toastService.successWithMessage('A link to data will be emailed to you within an hour.');
    }
    return this._http.post(`${this.config.ServerApiUrl}/exports/getProduct/new`,{data:data,userEmail:userEmail,isCompetitor:isCompetitor})
  }


  // products brands 
  public getAllBrands(skip, limit, query) {
    const queryData = { 'query': query };
    return this._http.post(`${this.config.ServerApiUrl}/brand/getAllBrands/${skip * limit}/${limit}`, queryData);
  }
  public addBrand(data) {
    return this._http.post(`${this.config.ServerApiUrl}/brand/addBrand`, data)
  }
  public brandArchiveStatus(status, brandId) {
    return this._http.post(`${this.config.ServerApiUrl}/brand/archiveStatus`, { status: status, brandId: brandId });

  }
  public editBrand(data) {
    return this._http.patch(`${this.config.ServerApiUrl}/brand/editBrand`, data)
  }

  public getSingleBrand(id) {
    return this._http.post(`${this.config.ServerApiUrl}/brand/getBrand`,{id:id})
  }
  public brandsList(data) {
    return this._http.post(`${this.config.ServerApiUrl}/brand/allBrands`, {
      data: data
    });
  }
  public productsFiltersData(data) {
    return this._http.post(`${this.config.ServerApiUrl}/product/productsFiltersData`, { data: data })
  }

  public getCountries(data) {
    return this._http.post(`${this.config.ServerApiUrl}/product/getCountries`, { data: data })
  }
  public checkMissingFeilds(data) {
    return this._http.post(`${this.config.ServerApiUrl}/product/checkMissingFeilds`,{data:data})
  }
  public createSystemLog(data) {
    return this._http.post(`${this.config.ServerApiUrl}/systemlogs/createSystemLog`, data)
  }

  public exportProductMedia(obj) {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/exports/exportProductMedia`, obj).subscribe(values => {
        ok(values);
        this.toastService.successWithMessage('A link to data will be emailed to you within an hour.');
      }, err => {
        notOk(err);
        this.toastService.error('Unable to export at this moment');
      });
    });
  }
}
